export const buildValidationErros = function (errors: any) {
    let message = [];

    for (const [, value] of Object.entries(errors)) {
        message.push(`- ${value}`);
    }

    return message.join('\n');
}